// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export type QueryValue = string | number | boolean | null | undefined;

export function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function buildQueryString(query?: Record<string, QueryValue>): string {
  if (!query) {
    return "";
  }

  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) {
      continue;
    }

    searchParams.set(key, String(value));
  }

  const serializedQuery = searchParams.toString();
  return serializedQuery.length > 0 ? `?${serializedQuery}` : "";
}

export function readResponseTextOrEmpty(response: Response): Promise<string> {
  return response.text();
}
